import React from 'react';
import { SlackConfig } from 'api/integrations/slack/slack.types';
import { PageLoading } from 'components/atoms/loading';
import {
  SlackIntegrationDisconnectedPage,
  SlackIntegrationPage,
} from 'components/pages/integrations';
import {
  useQuerySlackAuthMeta,
  useQuerySlackConfig,
} from 'queries/slack-integration';

const getConfig = (data?: SlackConfig[]) => data?.[0];

const DisconnectSlackLandingPage = () => {
  const { data, status } = useQuerySlackAuthMeta();

  switch (status) {
    case 'loading': {
      return <PageLoading />;
    }

    case 'success': {
      return <SlackIntegrationDisconnectedPage authMeta={data} />;
    }

    case 'error':
    case 'idle':
    default: {
      return null;
    }
  }
};

export const SlackLandingPage = () => {
  const { data: metaData, status: metaStatus } = useQuerySlackAuthMeta();
  const { data, status } = useQuerySlackConfig({
    enabled: metaStatus === 'success',
  });

  switch (status) {
    case 'loading': {
      return <PageLoading />;
    }

    case 'success': {
      const slackConfig = getConfig(data);

      if (slackConfig) {
        return (
          <SlackIntegrationPage config={slackConfig} authMeta={metaData} />
        );
      }

      return <DisconnectSlackLandingPage />;
    }

    case 'error':
    case 'idle':
    default: {
      return null;
    }
  }
};
